export const DEFAULT_COMPANY = {
  company_name: "Acme Holdings (Pty) Ltd",
  registration_number: "2015/123456/07",
  vat_number: "4123456789",
  sdl_number: "L123456789",
  registered_seta: "Services SETA",
  industry: "Professional Services",
  financial_year_end: "December",
  company_address: "123 Main Street, Sandton, Johannesburg, 2196",
  company_phone: "+27 11 123 4567",
  company_website: "www.acmeholdings.co.za",
};

export const DEFAULT_BBEE = {
  bee_level: "Level 2",
  bee_status: "Verified",
  measurement_period: "January 2025 - December 2025",
  total_employees: "156",
  black_ownership: "51.2%",
  black_female_ownership: "26.8%",
  certificate_expiry: "15 March 2026",
  last_verification: "16 March 2025",
};

export const DEFAULT_VERIFICATION_AGENCY = {
  name: "BEE Verification Services (Pty) Ltd",
  accreditation_body: "SANAS Accredited",
  accreditation_number: "BVA-2024-001",
  contact_person: "Mr. Peter Mokoena",
  email: "peter@beeverify.co.za",
  phone: "+27 12 345 6789",
  address: "45 Corporate Drive, Rosebank, Johannesburg, 2196",
  website: "www.beeverify.co.za",
};

export const DEFAULT_VERIFICATION_DOCUMENTS = [
  {
    id: 1,
    title: "Verification Contract",
    filename: "Verification_Contract_2024-2026.pdf",
    upload_date: "10 January 2024",
    expiry_date: "31 December 2026",
  },
  {
    id: 2,
    title: "Engagement Letter",
    filename: "Engagement_Letter_FY2025.pdf",
    upload_date: "5 January 2025",
    expiry_date: "31 December 2025",
  },
  {
    id: 3,
    title: "Non-Disclosure Agreement",
    filename: "NDA_BEE_Verification_Services.pdf",
    upload_date: "10 January 2024",
    expiry_date: "31 December 2026",
  },
];

export const DEFAULT_CONSULTANT = {
  firm: "BEE Advisory Partners (Pty) Ltd",
  registration_number: "2018/567890/07",
  contract_start: "1 January 2024",
  contract_end: "31 December 2025",
  address: "45 Corporate Drive, Rosebank, Johannesburg, 2196",
  phone: "+27 11 987 6543",
  email: "info@beeadvisory.co.za",
  website: "www.beeadvisory.co.za",

  assigned: {
    name: "Linda Mabaso",
    title: "Senior BEE Consultant",
    email: "linda.mabaso@beeadvisory.co.za",
    phone: "+27 82 999 8888",
    specializations: [
      "B-BBEE Strategy",
      "Verification Support",
      "Skills Development",
    ],
  },
};


export const DEFAULT_CONSULTANT_DOCUMENTS = [
  {
    id: 1,
    title: "Power of Attorney",
    filename: "POA_BEE_Advisory_2024.pdf",
    upload_date: "15 January 2024",
    expiry_date: "31 December 2025",
  },
  {
    id: 2,
    title: "Non-Disclosure Agreement",
    filename: "NDA_BEE_Advisory_Partners.pdf",
    upload_date: "15 January 2024",
    expiry_date: "31 December 2026",
  },
];

export const DEFAULT_BEE_MANAGER = {
  full_name: "John Dlamini",
  role: "BEE Manager (Compliance)",
  email: "john.dlamini@acmeholdings.co.za",
  phone: "+27 82 123 4567",
  responsibilities: [
    "Overall B-BBEE strategy and compliance",
    "Verification process management",
    "Element coordination and reporting",
    "Stakeholder communication",
  ],
};

export const DEFAULT_BEE_ELEMENT_OWNERS = [
  {
    id: 1,
    element_name: "Ownership",
    owner_name: "Sarah Nkosi",
    owner_role: "Company Secretary",
    icon: "bi bi-people",
  },
  {
    id: 2,
    element_name: "Management Control & EE",
    owner_name: "Thabo Molefe",
    owner_role: "HR Manager",
    icon: "bi bi-building",
  },
  {
    id: 3,
    element_name: "Skills Development",
    owner_name: "Nomsa Mthembu",
    owner_role: "Training Manager",
    icon: "bi bi-mortarboard",
  },
  {
    id: 4,
    element_name: "Enterprise & Supplier Dev",
    owner_name: "Ayanda Sithole",
    owner_role: "Procurement Manager",
    icon: "bi bi-box-seam",
  },
  {
    id: 5,
    element_name: "Socio-Economic Dev",
    owner_name: "Nomvula Khumalo",
    owner_role: "CSI Manager",
    icon: "bi bi-heart",
  },
  {
    id: 6,
    element_name: "YES Programme",
    owner_name: "Thabo Molefe",
    owner_role: "HR Manager",
    icon: "bi bi-award",
  },
];
